module.exports = __webpack_public_path__ + "static/media/stairs-icon.dcf89ec3.svg";